import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';
@Component({
  selector: 'app-extra-time-rules',
  templateUrl: './extra-time-rules.component.html',
  styleUrls: ['./extra-time-rules.component.scss']
})
export class ExtraTimeRulesComponent implements OnInit {
  button = {}
  date = new Date();
  delayRuleType: any = [];
  durationType: any = [];
  TaxableStatus: any = []
  fromvalue: number = 0;
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang: any;
  customDataSource: any;
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  //dropdown
  constructor(public Objects: ObjectsService, public router: Router, public activeRoute: ActivatedRoute,public translate:TranslateService,
    public gt: genericCustomStoreService, public _publicSettingService: publicSettingService) {
    gt.seturl("ExtraTimeRule");
    gt.submit();
    this.customDataSource = gt.customDataSource;
    this.button = Objects.button;
    //get dropdown
    this.durationType = Objects.durationType;
    this.TaxableStatus = Objects.TaxableStatus;
    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );

    loadMessages({
      en: { "Yes": this.translate.instant('personal.yes'), "No": this.translate.instant('personal.no') }
  });

  }

  ngOnInit(): void { }

  extraform(e: any) {
    this.router.navigate(['../add-edit-ExtraTimeRules'], { relativeTo: this.activeRoute })
    this._publicSettingService.$ETRRA_TIME.next(e.key ? e.key : 0)

  }

  onEditorPreparing(e: any) {
    this.gt.onEditorPreparing(e)
  }
  addrowfun(name: string) {
    return this.gt.addrow(name)
  }
}

